// extracted by mini-css-extract-plugin
export default {"social-media-links":"dwPIT3K","social-media-links__list":"CJmJfaE","social-media-links__item":"_RvBog0"};